// ─── Board ────────────────────────────────────────────────────────────────────
export const BOARD_COLS  = 6
export const BOARD_ROWS  = 13
export const SPAWN_COL   = 2   // 0-indexed column where pieces enter
export const SPAWN_ROW   = 1   // main block row at spawn (sub is at row-1)

// ─── Cell values ──────────────────────────────────────────────────────────────
export const CELL_EMPTY   = 0
export const CELL_GARBAGE = 6
export const COLORS       = 5  // 1-5 are the colored blocks

// ─── Piece sub-block offsets by rotation (dcol, drow from main block) ─────────
export const SUB_OFFSETS: [number, number][] = [
  [ 0, -1],  // 0 – sub is ABOVE  (default spawn)
  [ 1,  0],  // 1 – sub is RIGHT
  [ 0,  1],  // 2 – sub is BELOW
  [-1,  0],  // 3 – sub is LEFT
]

// ─── Score / chain tables (Puyo Puyo 1 formula) ───────────────────────────────
export const CHAIN_POWER: number[] = [
  0, 8, 16, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320,
]
// For chains beyond the table length, add 32 per extra wave.

export const COLOR_BONUS: number[] = [0, 0, 3, 6, 12, 24]
// index = number of distinct colors that popped in the wave

export const GROUP_BONUS: number[] = [0, 0, 0, 0, 0, 2, 3, 4, 5, 6, 7, 10]
// index = group size; 11+ → use index 11 (value 10)

// ─── Garbage conversion thresholds (diminishing returns, no hard cap) ─────────
export const GARBAGE_RATE_1 = 70    // score per garbage bean – tier 1
export const GARBAGE_RATE_2 = 140   // tier 2 (after threshold 1)
export const GARBAGE_RATE_3 = 280   // tier 3 (after threshold 2)
export const GARBAGE_THRESHOLD_1 = 2100   // ~30 beans at normal rate
export const GARBAGE_THRESHOLD_2 = 5600   // +20 beans at half rate

// ─── Timing constants (seconds) ───────────────────────────────────────────────
export const CHAIN_FLASH_DURATION   = 0.40  // cells flash before popping
export const CHAIN_FALL_DURATION    = 0.18  // pause after gravity per chain wave
export const CHAIN_DISPLAY_DURATION = 2.50  // how long chain counter stays on screen

// ─── Speed rooms (cells per second) ───────────────────────────────────────────
export const SPEEDS = {
  slow:   1,
  normal: 3,
  fast:   6,
  turbo:  12,
} as const

// ─── DAS (Delayed Auto Shift) ─────────────────────────────────────────────────
export const DAS_DELAY  = 0.150  // seconds before auto-repeat kicks in
export const DAS_REPEAT = 0.050  // seconds between each auto-repeat move

// ─── Colors (Phaser hex, bright versions) ─────────────────────────────────────
export const BLOCK_COLOR: Record<number, number> = {
  0: 0x12122a,  // empty  (board bg)
  1: 0xFF6B6B,  // Red
  2: 0x4CC9F0,  // Blue
  3: 0x4ECB71,  // Green
  4: 0xFFE566,  // Yellow
  5: 0xC77DFF,  // Purple
  6: 0xADB5BD,  // Garbage (gray)
}

export const BLOCK_DARK: Record<number, number> = {
  0: 0x0a0a18,
  1: 0xA83232,
  2: 0x2A8BB5,
  3: 0x2E8B47,
  4: 0xCCAD22,
  5: 0x8B4DC7,
  6: 0x6C757D,
}
